import "./Component/Register.css";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import React, { useEffect } from "react";
import { Avatar, StepLabel, Typography } from "@mui/material";
import StepForm1 from "./Component/StepForm1";
import StepForm2 from "./Component/StepForm2";
import StepForm3 from "./Component/StepForm3";
import StepForm4 from "./Component/StepForm4";
import StepForm5 from "./Component/StepForm5";
import StepForm6 from "./Component/StepForm6";
import StepForm7 from "./Component/StepForm7";
import { FnBlock_UI } from "components/BlockUI";
import { AxiosGet, AxiosPost } from "utilities/Axios";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from "components/FormItem/yupFormSchemas";
import { undefinedOrNull } from "utilities/Function";
import { SwAlert } from "components/Alert";
import { AlertMsg, AlertTitle } from "config/AlertMsgConfig";
const RegisterContext = React.createContext(null);
const Register = () => {
    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const steps = ['ข้อมูลส่วนตัว', 'ข้อมูลการติดต่อ', 'ข้อมูลการประวัติการศึกษา', 'ความรู้ความสามารถพิเศษ', 'ประวัติการทำงานและกิจกรรมอื่นๆ', 'ข้อมูลส่วนตัวอื่นๆ เพิ่มเติม', 'ข้อมูลส่วนอื่นๆ'];
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set<number>());
    const [objMasterData, setobjMasterData] = React.useState({});
    const [arrDistrict1, setarrDistrict1] = React.useState([]);
    const [arrDistrict2, setarrDistrict2] = React.useState([]);
    const [arrTambon1, setarrTambon1] = React.useState([]);
    const [arrTambon2, setarrTambon2] = React.useState([]);
    const [arrStudy, setarrStudy] = React.useState([]);
    const [arrLanguageAbility, setarrLanguageAbility] = React.useState([]);
    const [arrTWorkHistory, setarrTWorkHistory] = React.useState([]);
    const [arrTrainingHistory, setarrTrainingHistory] = React.useState([]);
    const [nReplyID1, setnReplyID1] = React.useState(null);
    const [nReplyID9, setnReplyID9] = React.useState(null);
    const [nReplyID7, setnReplyID7] = React.useState(null);
    const [nReplyID8, setnReplyID8] = React.useState(null);
    const [nReplyID11, setnReplyID11] = React.useState(null);
    const [nReplyID10, setnReplyID10] = React.useState(null);
    const [nReplyID12, setnReplyID12] = React.useState(null);
    const [nReplyID3, setnReplyID3] = React.useState(null);
    const [isAgree, setisAgree] = React.useState(false);
    const [arrFile, setarrFile] = React.useState([]);
    const [objFileImg, setobjFileImg] = React.useState(null);
    const [nSexID, setnSexID] = React.useState(null);
    const [isSameAddress, setisSameAddress] = React.useState(false);

    const isStepSkipped = (step: number) => {
        return skipped.has(step);
    };
    const handleNext = () => {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    useEffect(() => {
        BlockUI();
        AxiosGet("Register/onPageLoadRegister", {}, (res) => {
            setobjMasterData(res || {})
        }, null, null, null, () => {
            UnBlockUI();
        })
    }, [])

    //#region  Form
    const objSchema1 = yup.object().shape({
        nPositionID: yupFormSchemas.string("ตำเหน่งงานที่สนใจ", { required: true }),
        nSalary: yupFormSchemas.string("เงินเดือนขั้นต่ำที่คาดหวัง", { required: true }),
        nNewSourceID: yupFormSchemas.string("แหล่งข่าวการสมัครงาน", { required: true }),
        sIDCard: yupFormSchemas.stringIDCard("เลขที่บัตรประชาชน", { required: true }),
        dIDcardExpiration: yupFormSchemas.string("วันที่หมดอายุ", { required: true }),
        nPrefixID: yupFormSchemas.string("คำนำหน้า", { required: true }),
        sFirstName_TH: yupFormSchemas.string("ชื่อ (ไทย)", { required: true }),
        sLastName_TH: yupFormSchemas.string("นามสกุล (ไทย)", { required: true }),
        sFirstName_EN: yupFormSchemas.string("ชื่อ (อังกฤษ)", { required: true }),
        sLastName_EN: yupFormSchemas.string("นามสกุล (อังกฤษ)", { required: true }),
        sNickname: yupFormSchemas.string("ชื่อเล่น", { required: true }),
        dBirthday: yupFormSchemas.string("วันเกิด", { required: true }),
        nNationalityID: yupFormSchemas.string("สัญชาติ", { required: true }),
        nEthnicityID: yupFormSchemas.string("เชื้อชาติ", { required: true }),
        nReligionID: yupFormSchemas.string("ศาสนา", { required: true }),
        nSexID: yupFormSchemas.string("เพศ", { required: true }),
        nMaritalStatusID: yupFormSchemas.string("สถานภาพสมรส", { required: true }),
        nWeight: yupFormSchemas.string("น้ำหนัก", { required: true }),
        nHeight: yupFormSchemas.string("ส่วนสูง", { required: true }),
        nMilitaryStatusID: yupFormSchemas.string("สถานภาพทางทหาร", { required: nSexID === 15 }),
    });

    const formStep1 = useForm({
        resolver: yupResolver(objSchema1),
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });

    const objSchema2 = yup.object().shape({
        sVillage1: yupFormSchemas.string("หมู่บ้าน", { required: false }),
        sHouseNumber1: yupFormSchemas.string("เลขที", { required: true }),
        nMoo1: yupFormSchemas.string("หมู่ที่", { required: false }),
        sChoi1: yupFormSchemas.string("ชอย", { required: false }),
        sRoad1: yupFormSchemas.string("ถนน", { required: false }),
        nProvince1ID: yupFormSchemas.string("จังหวัด", { required: true }),
        nDistrict1ID: yupFormSchemas.string("อำเภอ/เขต", { required: true }),
        nSubDistrict1ID: yupFormSchemas.string("ตำบล/แขวง", { required: true }),
        sZipCode1: yupFormSchemas.string("รหัสไปรษณีย์", { required: true }),
        sVillage2: yupFormSchemas.string("หมู่บ้าน", { required: false }),
        sHouseNumber2: yupFormSchemas.string("เลขที", { required: true }),
        nMoo2: yupFormSchemas.string("หมู่ที่", { required: false }),
        sChoi2: yupFormSchemas.string("ชอย", { required: false }),
        sRoad2: yupFormSchemas.string("ถนน", { required: false }),
        nProvince2ID: yupFormSchemas.string("จังหวัด", { required: true }),
        nDistrict2ID: yupFormSchemas.string("อำเภอ/เขต", { required: true }),
        nSubDistrict2ID: yupFormSchemas.string("ตำบล/แขวง", { required: true }),
        sZipCode2: yupFormSchemas.string("รหัสไปรษณีย์", { required: true }),
        sEmail: yupFormSchemas.email("อีเมล์", { required: true }),
        sIDLine: yupFormSchemas.string("ID Line", { required: false }),
        sFacebook: yupFormSchemas.string("Facebook", { required: false }),
        sMobileNumber: yupFormSchemas.string("เบอร์มือถือ", { required: true }).min(10, "เบอร์มือถือไม่ถูกต้อง"),
        sContactFName: yupFormSchemas.string("ชื่อบิดา/มารดา/หรือญาติ", { required: true }),
        sContactLName: yupFormSchemas.string("นามสกุล", { required: true }),
        sRelationshipID: yupFormSchemas.string("ความสัมพันธ์", { required: true }),
        sContactMobile: yupFormSchemas.string("เบอร์มือถือ", { required: true }).min(10, "เบอร์มือถือไม่ถูกต้อง"),
        sContactFName1: yupFormSchemas.string("ชื่อบุคคลอื่นๆ", { required: true }),
        sContactLName1: yupFormSchemas.string("นามสกุล", { required: true }),
        sRelationship1: yupFormSchemas.string("ความสัมพันธ์", { required: true }),
        sContactMobile1: yupFormSchemas.string("เบอร์มือถือ", { required: true }).min(10, "เบอร์มือถือไม่ถูกต้อง"),
    });

    const formStep2 = useForm({
        resolver: yupResolver(objSchema2),
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });
    const objSchema4 = yup.object().shape({
        nTypingAbility_TH: yupFormSchemas.string("ไทย คำ/นาที", { required: true }),
        nTypingAbility_EN: yupFormSchemas.string("อังกฤษ คำ/นาที", { required: true }),
        isInternet: yupFormSchemas.string("Internet/Email", { required: true }),
        arrComputerPrograml: yupFormSchemas.stringArray("โปรแกรมคอมพิวเตอร์ที่ใช้ได้", { required: false }),
        sOtherAbilities: yupFormSchemas.string("ความสามารถอื่นๆ", { required: false }),
    });

    const formStep4 = useForm({
        resolver: yupResolver(objSchema4),
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });
    const objSchema6 = yup.object().shape({
        nReplyID1: yupFormSchemas.string("", { required: true }),
        nReplyID2: yupFormSchemas.string("", { required: true }),
        nReplyID3: yupFormSchemas.string("", { required: true }),
        nReplyID4: yupFormSchemas.string("", { required: true }),
        nReplyID5: yupFormSchemas.string("", { required: true }),
        nReplyID6: yupFormSchemas.string("", { required: true }),
        nReplyID7: yupFormSchemas.string("", { required: true }),
        nReplyID8: yupFormSchemas.string("", { required: true }),
        nReplyID9: yupFormSchemas.string("", { required: true }),
        nReplyID10: yupFormSchemas.string("", { required: true }),
        nReplyID11: yupFormSchemas.string("", { required: true }),
        sOther11: yupFormSchemas.string("", { required: nReplyID11 === 81 }),
        nReplyID12: yupFormSchemas.string("", { required: nSexID == 15 ? false : true }),
        // nContagiousID9: yupFormSchemas.string("", { required: true }),
        nGestational12: yupFormSchemas.string("", { required: nReplyID12 === 83 }),
        sOther9: yupFormSchemas.string("", { required: nReplyID9 === 94 }),
        lstOptionReplyID1: yupFormSchemas.stringArray("", { required: nReplyID1 === 63 }),
        lstOptionReplyID3: yupFormSchemas.stringArray("", { required: nReplyID3 === 67 }),
    });
    const formStep6 = useForm({
        resolver: yupResolver(objSchema6),
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });
    //#endregion

    //#region Load data
    const GetDistrictRegister = (nProvinceID: number, Mode: number) => {
        BlockUI();
        AxiosPost("Register/GetDistrictRegister", { nProvinceID: nProvinceID }, (res) => {
            console.log("ws", res);
            if (Mode === 1) {
                setarrDistrict1(res || []);
            } else {
                setarrDistrict2(res || []);
            }
        }, null, null, null, () => {
            UnBlockUI();
        })
    }
    const GetTambonRegister = (nDistrictID: number, Mode: number) => {
        BlockUI();
        AxiosPost("Register/GetTambonRegister", { nDistrictID: nDistrictID }, (res) => {
            console.log("ws", res);
            if (Mode === 1) {
                setarrTambon1(res || []);
            } else {
                setarrTambon2(res || []);
            }
        }, null, null, null, () => {
            UnBlockUI();
        })
    }
    //#endregion

    const onSentData = () => {
        let objData = {
            objFileImg: objFileImg,
            nPositionID: undefinedOrNull(formStep1.getValues("nPositionID"), "number"),
            nSalary: undefinedOrNull(formStep1.getValues("nSalary"), "number"),
            nNewSourceID: undefinedOrNull(formStep1.getValues("nNewSourceID"), "number"),
            nRecruitmentID: undefinedOrNull(formStep1.getValues("nRecruitmentID"), "number"),
            sIDCard: undefinedOrNull(formStep1.getValues("sIDCard"), "string"),
            dIDcardExpiration: undefinedOrNull(formStep1.getValues("dIDcardExpiration"), "dateToString"),
            nPrefixID: undefinedOrNull(formStep1.getValues("nPrefixID"), "number"),
            sFirstName_TH: undefinedOrNull(formStep1.getValues("sFirstName_TH"), "string"),
            sLastName_TH: undefinedOrNull(formStep1.getValues("sLastName_TH"), "string"),
            sFirstName_EN: undefinedOrNull(formStep1.getValues("sFirstName_EN"), "string"),
            sLastName_EN: undefinedOrNull(formStep1.getValues("sLastName_EN"), "string"),
            sNickname: undefinedOrNull(formStep1.getValues("sNickname"), "string"),
            dBirthday: undefinedOrNull(formStep1.getValues("dBirthday"), "dateToString"),
            nNationalityID: undefinedOrNull(formStep1.getValues("nNationalityID"), "number"),
            nReligionID: undefinedOrNull(formStep1.getValues("nReligionID"), "number"),
            nEthnicityID: undefinedOrNull(formStep1.getValues("nEthnicityID"), "number"),
            nSexID: undefinedOrNull(formStep1.getValues("nSexID"), "number"),
            nMaritalStatusID: undefinedOrNull(formStep1.getValues("nMaritalStatusID"), "number"),
            nWeight: undefinedOrNull(formStep1.getValues("nWeight"), "number"),
            nHeight: undefinedOrNull(formStep1.getValues("nHeight"), "number"),
            nMilitaryStatusID: undefinedOrNull(formStep1.getValues("nMilitaryStatusID"), "number"),
            sVillage1: undefinedOrNull(formStep2.getValues("sVillage1"), "string"),
            sHouseNumber1: undefinedOrNull(formStep2.getValues("sHouseNumber1"), "string"),
            nMoo1: undefinedOrNull(formStep2.getValues("nMoo1"), "number"),
            sChoi1: undefinedOrNull(formStep2.getValues("sChoi1"), "string"),
            sRoad1: undefinedOrNull(formStep2.getValues("sRoad1"), "string"),
            nProvince1ID: undefinedOrNull(formStep2.getValues("nProvince1ID"), "number"),
            nDistrict1ID: undefinedOrNull(formStep2.getValues("nDistrict1ID"), "number"),
            nSubDistrict1ID: undefinedOrNull(formStep2.getValues("nSubDistrict1ID"), "number"),
            isSameAddress: undefinedOrNull(formStep2.getValues("isSameAddress"), "bool"),
            sZipCode1: undefinedOrNull(formStep2.getValues("sZipCode1"), "string"),
            sVillage2: undefinedOrNull(formStep2.getValues("sVillage2"), "string"),
            sHouseNumber2: undefinedOrNull(formStep2.getValues("sHouseNumber2"), "string"),
            nMoo2: undefinedOrNull(formStep2.getValues("nMoo2"), "number"),
            sChoi2: undefinedOrNull(formStep2.getValues("sChoi2"), "string"),
            sRoad2: undefinedOrNull(formStep2.getValues("sRoad2"), "string"),
            nProvince2ID: undefinedOrNull(formStep2.getValues("nProvince2ID"), "number"),
            nDistrict2ID: undefinedOrNull(formStep2.getValues("nDistrict2ID"), "number"),
            nSubDistrict2ID: undefinedOrNull(formStep2.getValues("nSubDistrict2ID"), "number"),
            sZipCode2: undefinedOrNull(formStep2.getValues("sZipCode2"), "string"),
            sEmail: undefinedOrNull(formStep2.getValues("sEmail"), "string"),
            sIDLine: undefinedOrNull(formStep2.getValues("sIDLine"), "string"),
            sFacebook: undefinedOrNull(formStep2.getValues("sFacebook"), "string"),
            sMobileNumber: undefinedOrNull(formStep2.getValues("sMobileNumber"), "string"),
            sContactFName: undefinedOrNull(formStep2.getValues("sContactFName"), "string"),
            sContactLName: undefinedOrNull(formStep2.getValues("sContactLName"), "string"),
            sRelationshipID: undefinedOrNull(formStep2.getValues("sRelationshipID"), "number"),
            sContactMobile: undefinedOrNull(formStep2.getValues("sContactMobile"), "string"),

            sContactFName1: undefinedOrNull(formStep2.getValues("sContactFName1"), "string"),
            sContactLName1: undefinedOrNull(formStep2.getValues("sContactLName1"), "string"),
            sRelationship1: undefinedOrNull(formStep2.getValues("sRelationship1"), "string"),
            sContactMobile1: undefinedOrNull(formStep2.getValues("sContactMobile1"), "string"),

            nTypingAbility_TH: undefinedOrNull(formStep4.getValues("nTypingAbility_TH"), "number"),
            nTypingAbility_EN: undefinedOrNull(formStep4.getValues("nTypingAbility_EN"), "number"),
            isInternet: undefinedOrNull(formStep4.getValues("isInternet"), "number"),
            arrComputerPrograml: formStep4.getValues("arrComputerPrograml") || [],
            sOtherAbilities: undefinedOrNull(formStep4.getValues("sOtherAbilities"), "string"),
            nReplyID1: undefinedOrNull(formStep6.getValues("nReplyID1"), "number"),
            nReplyID2: undefinedOrNull(formStep6.getValues("nReplyID2"), "number"),
            nReplyID3: undefinedOrNull(formStep6.getValues("nReplyID3"), "number"),
            nReplyID4: undefinedOrNull(formStep6.getValues("nReplyID4"), "number"),
            nReplyID5: undefinedOrNull(formStep6.getValues("nReplyID5"), "number"),
            nReplyID6: undefinedOrNull(formStep6.getValues("nReplyID6"), "number"),
            nReplyID7: undefinedOrNull(formStep6.getValues("nReplyID7"), "number"),
            nReplyID8: undefinedOrNull(formStep6.getValues("nReplyID8"), "number"),
            nReplyID9: undefinedOrNull(formStep6.getValues("nReplyID9"), "number"),
            nReplyID10: undefinedOrNull(formStep6.getValues("nReplyID10"), "number"),
            nReplyID11: undefinedOrNull(formStep6.getValues("nReplyID11"), "number"),
            nReplyID12: undefinedOrNull(formStep6.getValues("nReplyID12"), "number"),
            nContagiousID9: undefinedOrNull(formStep6.getValues("nContagiousID9"), "number"),
            sOther11: undefinedOrNull(formStep6.getValues("sOther11"), "string"),
            sOther7: undefinedOrNull(formStep6.getValues("sOther7"), "string"),
            sOther8: undefinedOrNull(formStep6.getValues("sOther8"), "string"),
            sOther9: undefinedOrNull(formStep6.getValues("sOther9"), "string"),
            sOther10: undefinedOrNull(formStep6.getValues("sOther10"), "string"),
            nGestational12: undefinedOrNull(formStep6.getValues("nGestational12"), "number"),
            lstFileUpLoad: arrFile || [],
            arrStudy: arrStudy || [],
            arrLanguageAbility: arrLanguageAbility || [],
            arrTWorkHistory: arrTWorkHistory || [],
            arrTrainingHistory: arrTrainingHistory || [],
            isConsent: isAgree,
            lstOptionReplyID1: formStep6.getValues("lstOptionReplyID1") ? formStep6.getValues("lstOptionReplyID1") : [],
            lstOptionReplyID3: formStep6.getValues("lstOptionReplyID3") ? formStep6.getValues("lstOptionReplyID3") : [],
        }
        console.log("lst", objData);
        SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmSave, () => {
            BlockUI();
            AxiosPost("Register/SaveDataRegister", objData, (res) => {
                SwAlert.Success(AlertTitle.Success, AlertMsg.SaveComplete, () => {
                    window.location.reload();
                });
            }, null, null, null, () => {
                UnBlockUI();
            })
        });

    }
    return (
        <div className="body">
            <div className="fromcontent">
                <div className="card">
                    <div className="card-border-top"> </div>
                    <p className="text1">แบบฟอร์มการสมัครออนไลน์</p>
                    <div className="form-step">
                        <div id="divStep">
                            <Stepper activeStep={activeStep}>
                                {steps.map((label, index) => {
                                    const stepProps: { completed?: boolean } = {};
                                    const labelProps: {
                                        optional?: React.ReactNode;
                                    } = {};
                                    if (isStepSkipped(index)) {
                                        stepProps.completed = false;

                                    }
                                    return (
                                        <Step key={label} {...stepProps}>
                                            <StepLabel {...labelProps}>{label}</StepLabel>
                                        </Step>
                                    );
                                })}
                            </Stepper>
                        </div>
                        <div id="divStepMoble">
                            <Avatar
                                alt="Remy Sharp"
                                sx={{ width: 24, height: 24, fontSize: "0.75rem", bgcolor: "#1976d2" }}
                            >
                                {activeStep + 1}
                            </Avatar>
                            <p>{steps[activeStep]}</p>
                        </div>
                    </div>
                    <RegisterContext.Provider value={{
                        handleNext: handleNext, handleBack: handleBack,
                        GetDistrictRegister: GetDistrictRegister,
                        GetTambonRegister: GetTambonRegister,
                        arrDistrict1: arrDistrict1,
                        arrDistrict2: arrDistrict2,
                        arrTambon1: arrTambon1,
                        arrTambon2: arrTambon2,
                        objMasterData: objMasterData,
                        formStep1: formStep1,
                        formStep2: formStep2,
                        formStep4: formStep4,
                        arrStudy: arrStudy,
                        setarrStudy: setarrStudy,
                        arrLanguageAbility: arrLanguageAbility,
                        setarrLanguageAbility: setarrLanguageAbility,
                        arrTWorkHistory: arrTWorkHistory,
                        setarrTWorkHistory: setarrTWorkHistory,
                        arrTrainingHistory: arrTrainingHistory,
                        setarrTrainingHistory: setarrTrainingHistory,
                        formStep6: formStep6,
                        nReplyID1: nReplyID1,
                        setnReplyID1: setnReplyID1,
                        isAgree: isAgree,
                        setisAgree: setisAgree,
                        arrFile: arrFile,
                        setarrFile: setarrFile,
                        onSentData: onSentData,
                        objFileImg: objFileImg,
                        setobjFileImg: setobjFileImg,
                        nSexID: nSexID,
                        setnSexID: setnSexID,
                        isSameAddress: isSameAddress,
                        setisSameAddress: setisSameAddress,
                        nReplyID9: nReplyID9,
                        setnReplyID9: setnReplyID9,
                        nReplyID11: nReplyID11,
                        setnReplyID11: setnReplyID11,
                        nReplyID10: nReplyID10,
                        setnReplyID10: setnReplyID10,
                        nReplyID12: nReplyID12,
                        setnReplyID12: setnReplyID12,
                        nReplyID3: nReplyID3,
                        setnReplyID3: setnReplyID3,
                        nReplyID7: nReplyID7,
                        setnReplyID7: setnReplyID7,
                        nReplyID8: nReplyID8,
                        setnReplyID8: setnReplyID8
                    }}>
                        <div className="Spetcontent">
                            {(() => {
                                switch (activeStep) {
                                    case 0:
                                        return (<StepForm1 />);
                                    case 1:
                                        return (<StepForm2 />);
                                    case 2:
                                        return (<StepForm3 />);
                                    case 3:
                                        return (<StepForm4 />);
                                    case 4:
                                        return (<StepForm5 />);
                                    case 5:
                                        return (<StepForm6 />);
                                    case 6:
                                        return (<StepForm7 />);
                                }
                            })()}
                        </div>
                    </RegisterContext.Provider>
                </div>
            </div>
            <footer className="footer">
                <div className="waves">
                    <div className="wave" id="wave1"></div>
                    <div className="wave" id="wave2"></div>
                    <div className="wave" id="wave3"></div>
                    <div className="wave" id="wave4"></div>
                </div>
                {/* <p>&copy;2023</p> */}
            </footer>
        </div>
    )
};
export { RegisterContext };
export default Register;